import { createAction, createAsyncThunk } from '@reduxjs/toolkit';

import { dialog } from 'app/utils';
import i18n from 'app/i18n';
import { lookups } from 'app/services';
import { IGlobalState } from 'app/models';
import { options, utils } from './options';
import { getLookup } from './selectors';

export const cacheLookup = createAction<Record<string, any>>('lookup/cache');
export const clearLookup = createAction('lookup/clear');

export interface IFetchOptions {
  key: string;
  params?: Record<string, any>;

  force?: boolean;
  silent?: boolean;
}

export const fetchLookup = createAsyncThunk('lookup/fetch', async (args: string | IFetchOptions, { dispatch, getState }) => {
  if (typeof args === 'string') args = { key: args };

  const { key, params, force, silent } = args, name = utils.encode(key, params);
  const lookup = getLookup(getState() as IGlobalState, key);
  if (lookup && !force) return;

  const { path, params: defaults } = (options[key] ?? {});
  if (!path) return;

  await lookups.query(path, { ...defaults, ...params })!.then(({ success, data, errors }) => {
    if (success) dispatch(cacheLookup({ [name]: data }));
    else if (!silent) errors?.forEach(({ code, message }) => {
      dialog.toast({ severity: 'error', title: i18n.t(`app.errors.${code}`), message });
    });
  });
});

export const reloadLookup = createAsyncThunk('lookup/reload', async (_, { dispatch, getState }) => {
  const { lookup } = getState() as IGlobalState;
  const keys = Object.keys(lookup ?? {});

  await Promise.all(keys.map(async (name) => {
    const [key, params] = utils.decode(name);
    await dispatch(fetchLookup({ key, params, force: true, silent: true }));
  }));
});
